/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class ProcessTabDirective {
    public restrict = 'E';
    public scope;
    public template;
    public value;
    listType: any;

    constructor(private Process: IProcessService, private bsLoadingOverlayService: IBsLoadingService) {
        this.restrict = 'E';
        this.scope = {
            queryType: "@",
            requestType: '=',
            requestSubType: '=',
            requestor: '=?',
            selectFunc: '=',
        };
        this.template = `
        <div class="panel">
            <div class="padding-style-1 white-background table-padding tab-table-border">
                <div class="info-panel md-custom-table" data-ng-if="typeArray.length == 0">No requests found</div>
                <table class="table table-material md-custom-table" bs-loading-overlay="requests_loader" ng-if="typeArray.length > 0">
                    <thead>
                        <tr>
                            <th class="w-20 first_col sorted_by_this">Process</th>
                            <th class="d-none d-md-table-cell">Date Started</th>
                            <th class="d-none d-md-table-cell">State</th>
                            <th>Type</th>
                            <th ng-if="request_state==='approved'" class="w-20 d-none d-xl-table-cell">Date Accepted</th>
                            <th ng-if="request_state==='rejected'" class="w-20 d-none d-xl-table-cell">Date Rejected</th>
                            <th class="w-20 d-none d-xl-table-cell">Purpose</th>
                            <th class="d-none d-md-table-cell">Steps to Success</th>
                            <th>Started By</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="c-pointer" data-ng-repeat="process in typeArray | orderBy: &quot;timestamp&quot;:true">
                            <td class="w-25 first_col sorted_by_this" data-ng-switch="process.type" data-ng-click="openProcess(process)" data-ng-class="{successed_request: process.extra.success , rejected_request: !process.extra.success , pending_request: !process.extra.finalized}">
                                <b>
                                    <span data-ng-switch-when="document">
                                        Document request:
                                        <span data-ng-bind="process.extra.transitions[0].data.type">
                                        </span>
                                    </span>
                                    <span data-ng-switch-when="leave">
                                        Leave request (starting from {{process.extra.data.start_date | date: 'dd.MM.yyyy'}} to {{process.extra.data.end_date | date: 'dd.MM.yyyy'}})
                                    </span>
                                    <span data-ng-switch-default="data-ng-switch-default">
                                        {{process.type | fieldtitle}}
                                    </span>
                                </b>
                            </td>
                            <td class="d-none d-md-table-cell" data-ng-click="openProcess(process)">{{process.timestamp | date: 'dd.MM.yyyy'}}</td>
                            <td class="d-none d-md-table-cell" data-ng-click="openProcess(process)">{{ [process.state] | next_steps }}</td>
                            <td data-ng-click="openProcess(process)"> {{(process.extra.data.type || &quot; &quot;) | fieldtitle}}</td>
                            <td ng-if="request_state==='approved'" data-ng-click="openProcess(process)">{{process.transitions[2].timestamp | date: 'dd.MM.yyyy'}}</td>
                            <td ng-if="request_state==='rejected'" data-ng-click="openProcess(process)">{{process.transitions[1].timestamp | date: 'dd.MM.yyyy'}}</td>
                            <td class="w-25 d-none d-xl-table-cell b-word" data-ng-switch="process.type" data-ng-click="openProcess(process)"><span>{{process.extra.data.purpose}}</span></td>
                            <td class="d-none d-md-table-cell" data-ng-click="openProcess(process)">{{ process._path.join(' &gt; ') }}</td>
                            <td data-ng-click="openProcess(process)">{{process.employee.displayname}}</td>
                            <td data-ng-if="C.hasPermission('org.change_org') && queryType !== 'incoming_deleted' && queryType !== 'outgoing_deleted'">
                                <div class="icon dropdown navbar-right bg-trans no-no-shadow" ng-show="C.User.hasPermission(&quot;org.change_org&quot;)">
                                    <md-button class="md-fab md-mini m--0" data-target="#" data-toggle="dropdown" aria-expanded="false">
                                        <md-icon class="p-0" md-font-library="material-icons">more_vert</md-icon>
                                    </md-button>
                                    <ul class="dropdown-menu d-menu">
                                        <li ng-if="C.canChangeLeaveTypeIncomming(process)"><a data-ng-click="C.changeLeaveType(process)">Change Leave Type </a></li>
                                        <li><a data-ng-click="C.deleteProcess(process.id, process)">Delete / Cancel</a></li>
                                        <li><a data-ng-click="C.archiveProcess(process.id, process)">Archive</a></li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="content paging-container m-t-10">
                <ul class="pagination flex-center" ng-show="listCount > maxPageItems">
                    <md-button class="md-raised md-primary d-inline-block" ng-disabled="disablePrev" data-ng-click="getList(pageNum_ - 1)">Previous</md-button>
                    <md-button class="md-raised md-primary d-inline-block pagination-button" data-ng-repeat="i in pageNums | limitTo:10 track by $index" data-ng-click="getList($index + 1)" data-ng-class="{&quot;bactive&quot;: $index + 1 == pageNum_}">{{$index + 1}}</md-button>
                    <md-button class="md-raised md-primary d-inline-block" ng-disabled="disableNext" data-ng-click="getList(pageNum_ + 1)">Next</md-button>
                </ul>
            </div>
        </div>
        `;
    }

    public link($scope: any, $element: any, attrs: any): void {
        $scope.request_direcion = attrs.queryType.split('_')[0];
        $scope.request_state = attrs.queryType.split('_')[1];
        this.getList($scope, 1);

        $scope.listCount = 0;
        $scope.pageNums = 0;
        $scope.maxPageItems = 10;
        $scope.pageNum_ = 1;
        $scope.typeArray = [];
        $scope.disablePrev = true;
        $scope.disableNext = false;

        $scope.$watch(() => $scope.requestType, (newValue, oldValue) => {
            if (newValue === oldValue) {
                return
            }
            $scope.pageNum_ = 1;
            $scope.getList($scope.pageNum_);
        });

        $scope.$watch(() => $scope.requestSubType, (newValue, oldValue) => {
            if (newValue === oldValue) {
                return
            }
            $scope.pageNum_ = 1;
            $scope.getList($scope.pageNum_);
        });

        $scope.$watch(() => $scope.requestor, (newValue, oldValue) => {
            if (newValue === oldValue) {
                return
            }
            $scope.pageNum_ = 1;
            $scope.getList($scope.pageNum_);
        });

        $scope.$watch(() => $scope.typeArray, (n) => {
            if ($scope.typeArray) {
                $scope.typeArray.map((p) => {
                    // purpose works normally have notes
                    // leaves
                    if (!p.extra.data.purpose && p.extra.data.note) {
                        p.extra.data['purpose'] = p.extra.data.note;
                    }
                    // expenses have descriptions
                    if (!p.extra.data.purpose && p.extra.data.description) {
                        p.extra.data['purpose'] = p.extra.data.description;
                    }

                    this.Process.getPath(p.type, p.state, p.path_to_success).then(
                        (path) => {
                            p._path = path;
                        });
                });
                $scope.pageNums = new Array(Math.ceil($scope.listCount / $scope.maxPageItems));
            }
        });

        $scope.openProcess = (process: any) => {
            $scope.selectFunc(process);
        }

        $scope.getList = (page_num: number) => {
            // angular struggles to manually read the disabled $index in the direct html so toggle it manually here
            // toggle next page button disable
            if (page_num === $scope.pageNums.length) {
                $scope.disableNext = true;
            } else {
                $scope.disableNext = false;
            }
            // toggle prev page button disable
            if (page_num === 1) {
                $scope.disablePrev = true;
            }   else {
                $scope.disablePrev = false;
            }
            this.bsLoadingOverlayService.start({ referenceId: 'requests_loader' });
            $scope.pageNum_ = page_num;
            let filter_options = {'query_type': $scope.queryType};

            if ($scope.requestType && $scope.requestType != 'all') {
                filter_options['type'] = $scope.requestType;
            }

            if ($scope.requestSubType && $scope.requestSubType != 'all') {
                filter_options['sub_type'] = $scope.requestSubType;
            }

            if ($scope.requestor) {
                filter_options['employee'] = $scope.requestor;

            }

            this.Process.getProcessList(filter_options, $scope.pageNum_).then((response: any) => {
                $scope.typeArray = response.results;
                $scope.listCount = response.count;
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
            });
        };
    }

    public getList($scope: any, page_num: number): any {
        this.bsLoadingOverlayService.start({ referenceId: 'requests_loader' });
        $scope.pageNum_ = page_num;
        let filter_options = {'query_type': $scope.queryType};

        if ($scope.requestType && $scope.requestType != 'all') {
            filter_options['type'] = $scope.requestType;
        }

        if ($scope.requestSubType && $scope.requestSubType != 'all') {
            filter_options['sub_type'] = $scope.requestSubType;
        }

        if ($scope.requestor) {
            filter_options['employee'] = $scope.requestor;

        }

        this.Process.getProcessList(filter_options, $scope.pageNum_).then((response: any) => {
            $scope.typeArray = response.results;
            $scope.listCount = response.count;
            this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
        });
    }

    public static DirectiveFn(
        Process: IProcessService,
        bsLoadingOverlayService: IBsLoadingService
    ): ProcessTabDirective {
        return new ProcessTabDirective(Process, bsLoadingOverlayService);
    }
}

ProcessTabDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService'];

angular.module('beneple.global').directive('processTab', ProcessTabDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/process_tab.directive.ts